var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('reservation-page',{scopedSlots:_vm._u([{key:"checkedin",fn:function(ref){
var reservation = ref.reservation;
var property = ref.property;
return [_c('reservation-checkedin-page',{attrs:{"reservation":reservation,"property":property},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var checkin = ref.checkin;
var getReservationCheckin = ref.getReservationCheckin;
return [(checkin.verification)?_c('user-identity-verification',{attrs:{"verification":checkin.verification}}):_c('v-alert',{staticClass:"mt-5",attrs:{"border":"left","colored-border":"","type":"warning"}},[_vm._v(" No ID verification available ")])]}}],null,true)},[_c('h2',{staticClass:"headline my-5"},[_vm._v("ID Verification")])])]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }